import React, { ReactNode } from 'react';
import { isAdmin } from 'src/common/session/SessionService';
import { Role } from './Role';

interface Props {
    fallback?: ReactNode;
}

export const AdminRole: React.FC<Props> = ({ children, fallback }) => (
    <Role isRole={isAdmin} fallback={fallback}>
        {children}
    </Role>
);
